import { Injectable, OnDestroy } from '@angular/core';

@Injectable()
export class DownloadService implements OnDestroy {

  constructor() {
  }

  ngOnDestroy() {
  }

  public DownloadBlob(res: Blob, fileType: string, fileName: string) {
    const blob = new Blob([res], { type: fileType});
    const url = window.URL.createObjectURL(blob);
    const filename = fileName;
    const a = document.createElement('a') as HTMLAnchorElement;

    a.href = url;
    a.download = filename;
    // document.body.appendChild(a);
    
    a.click();

    // document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }  
}